import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

const PutCuratorNicknameRequestSchema = z
  .object({
    nickname: z.string(),
  })
  .describe('PutCuratorNicknameRequestSchema');

const PutCuratorNicknameResponseDataSchema = z
  .object({
    curatorId: z.string(),
    nickname: z.string(),
  })
  .describe('PutCuratorNicknameResponseDataSchema');

const PutCuratorNicknameResponseSchema = createApiResponseSchema(
  PutCuratorNicknameResponseDataSchema,
);

type PutCuratorNicknameRequest = z.infer<typeof PutCuratorNicknameRequestSchema>;
type PutCuratorNicknameResponse = z.infer<typeof PutCuratorNicknameResponseSchema>;

export const putCuratorNickname = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PutCuratorNicknameRequestSchema),
    (request: PutCuratorNicknameRequest) =>
      executeStandardRequest(async () =>
        privateHttpClient.put<PutCuratorNicknameResponse>(
          profileApiPath.putCuratorNickname,
          request,
        ),
      ),
    validateApiResponse(PutCuratorNicknameResponseSchema),
  ),
);
